@if (targetForm) {
  <div class="create-intermediate-result-metric-container">

    <div class="hub-modal-header-text">
      <h5>{{!existingTarget ? 'Add' : 'Edit'}} Intermediate Result Target</h5>
    </div>

    <div class="content">
        <div class="row">
            <div class="col-md-12">
            <p class="text-center font-weight-bold sb-b p-1">
                Set a Target Value for your Intermediate Result
            </p>
            <h5 class="text-success text-center p-1">{{intermediateResult.indicatorName}}
            ({{intermediateResult.unit}})</h5>
            </div>
        </div>
        <app-intermediate-result-target-panel
            [targetForm]="targetForm"
            [intermediateResult]="intermediateResult">
        </app-intermediate-result-target-panel>
    </div>

    <div class="hub-modal-footer-text">
      <button class="cancel-button mr-1" (click)="cancel()">Cancel</button>

      <button type="button" class="hub-icon-button SaveButton" [ngClass]="{'saving': isSaving}"
        [disabled]="targetForm.invalid || isSaving" (click)="save()">
        <b>
          <i class="icon-floppy-disk"></i>
          <i class="icon-spinner4"></i>
        </b>
        Save
      </button>
    </div>

</div>
}
